import projDefaults from 'helpers/projects/projectDefaults'
import locationFromBounds from './helpers/locationFromBounds'
import mapType from './helpers/mapType'
import migrateCameras from './helpers/migrateCameras'
import migrateFloorPlans from './helpers/migrateFloorPlans'
import migrateMarkups from './helpers/migrateMarkups'
import compose from 'ramda/src/compose'
import path from 'ramda/src/path'
import defaultTo from 'ramda/src/defaultTo'

const { currentEntity, ui, entities } = projDefaults()
const markupsOrDefault = compose(defaultTo({}), path(['parameters', 'markups']))
const floorPlansOrDefault = compose(defaultTo({}), path(['parameters', 'floor_plans']))

export default async project => {
  const migratedCameras = await migrateCameras(project)

  return {
    currentEntity,
    ui,
    entities,
    zoom: parseFloat(project.parameters.zoom),
    cameras: migratedCameras,
    active: false,
    createdAt: Date.now(),
    updatedAt: Date.now(),
    title: project.title,
    location: locationFromBounds(project.parameters.bounds),
    mapType: mapType(project.parameters.mode),
    map: {
      markups: [
        ...migrateMarkups(markupsOrDefault(project))
      ],
      floorPlans: [
        ...migrateFloorPlans(floorPlansOrDefault(project))
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/schemas/migrator/index.js